import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {DateTimeSharedModule} from "../datetime/datetime.shared.module";
import {SystemSharedModule} from "../system/system.shared.module";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {AddressSharedModule} from "../address/address.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {
    AppItemAvailabilityEditFormComponent
} from "./app-item-availability/app-item-availability-edit-form/app-item-availability-edit-form.component";
import {
    AppItemAvailabilityEditModalComponent
} from "./app-item-availability/app-item-availability-edit-modal/app-item-availability-edit-modal.component";
import {
    AppItemAvailabilitySearchPageComponent
} from "./app-item-availability/app-item-availability-search-page/app-item-availability-search-page.component";
import {OrderProcessingSharedModule} from "../order-processing/order-processing.shared.module";
import {PricingModule} from "../pricing/pricing.module";
import {ZXingScannerModule} from "@zxing/ngx-scanner";

@NgModule({
    imports: [
        SharedModule,
        PosSharedModule,
        FrameworkModule,
        SystemSharedModule,
        DateTimeSharedModule,
        AddressSharedModule,
        PricingSharedModule,
        CustomersSharedModule,
        CustomObjectSharedModule,
        CatalogueSharedModule,
        OrderProcessingSharedModule,
        PricingModule,
        ZXingScannerModule
    ],
    declarations: [
        AppItemAvailabilityEditFormComponent,
        AppItemAvailabilityEditModalComponent,
        AppItemAvailabilitySearchPageComponent
    ],
    exports: [
        AppItemAvailabilitySearchPageComponent
    ]
})
export class WebOrderingModule {
}
